import { QButton } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../../../displayStrings';

type ExportEventTemplateButtonProps = {
  onClick: () => void;
};

const ExportEventTemplateButton = ({ onClick }: ExportEventTemplateButtonProps) => {
  return (
    <QButton variant="outline" onClick={onClick} data-cy="export-event-template-page-button">
      {DisplayStrings.EventTemplateExport}
    </QButton>
  );
};

export default ExportEventTemplateButton;
